import React from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import { getFullAttachmentUrl } from '@services/api/index.js'
const StudioDetail = ({ studio }) => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  
  if (!studio) return null

  const handleBack = () => {
    navigate('/studios')
  }

  return (
    <section className="py-16 bg-white">
      <div className="container section-padding">
        <div className="max-w-6xl mx-auto">
          {/* 工作室名称和返回按钮 */}
          <div className="mb-8 flex items-center justify-between">
            <h1 className="text-3xl md:text-4xl font-bold text-gray-900">
              {studio.name}
            </h1>
            
            <button
              onClick={handleBack}
              className="flex items-center text-gray-600 hover:text-gray-900 transition-colors"
            >
              <span className="inline-block w-4 h-4 mr-1">←</span>
              <span>返回列表</span>
            </button>
          </div>

          {/* 工作室基本信息 */}
          <div className="mb-12">
            
            <div className="flex items-center text-gray-600 mb-2">
              <span className="inline-block w-5 h-5 mr-2">📍</span>
              <span>{studio.region} {studio.address}</span>
            </div>
            
            <div className="flex items-center text-gray-600 mb-2">
              <span className="inline-block w-5 h-5 mr-2">👤</span>
              <span>联系人: {studio.linkman}</span>
            </div>
            
            <div className="flex items-center text-gray-600 mb-2">
              <span className="inline-block w-5 h-5 mr-2">✉️</span>
              <span>邮箱: {studio.email}</span>
            </div>
            
            <div className="flex items-center text-gray-600 mb-8">
              <span className="inline-block w-5 h-5 mr-2">📞</span>
              <span>电话: {studio.phone}</span>
            </div>
            
            <div className="flex items-center text-gray-600 mb-8">
              <span className="inline-block w-5 h-5 mr-2">📅</span>
              <span>成立时间: {studio.setDate}</span>
            </div>
            
            <p className="text-lg text-gray-700 leading-relaxed mb-12">
              {studio.summary}
            </p>
          </div>

          {/* 工作室使命和成就 */}
          <div className="border border-gray-200 rounded-lg p-8 mb-12">
            <h2 className="text-2xl font-bold text-gray-900 mb-6">工作室使命</h2>
            <p className="text-gray-700 leading-relaxed mb-10">
              {studio.mission}
            </p>
            
            <h2 className="text-2xl font-bold text-gray-900 mb-6">主要成就</h2>
            <p className="text-gray-700 leading-relaxed">
              {studio.achievement}
            </p>
          </div>

          {/* 工作室风采 */}
          <div className="mb-8">
            <h2 className="text-2xl font-bold text-gray-900 mb-6">工作室风采</h2>
            
            {/* 视频展示区域 */}
            {studio.videoId && (
              <div className="mb-12">
                <video 
                  src={getFullAttachmentUrl(studio.videoId)} 
                  controls 
                  className="w-full h-[500px] object-cover rounded-lg"
                >
                  您的浏览器不支持视频播放
                </video>
              </div>
            )}
            
            {/* 图片展示区域 */}
            {studio.imageIds && (
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
                {studio.imageIds.split(',').map((imageId, index) => (
                  <div key={index} className="bg-gray-100 rounded-lg overflow-hidden">
                    <img 
                      src={getFullAttachmentUrl(imageId)} 
                      alt={`工作室照片 ${index + 1}`} 
                      className="w-full h-64 object-cover"
                    />
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>
      </div>
    </section>
  )
}

export default StudioDetail 